import React, { useRef } from 'react';
import './VideoGallery.css'
import video0 from '../../../assets/videos/4_6048336584481183079.MOV';
import video1 from '../../../assets/videos/flat1.mp4';
import video2 from '../../../assets/videos/flat2.mp4';
import video3 from '../../../assets/videos/flat3.mp4';
import video4 from '../../../assets/videos/flat4.mp4';
import video5 from '../../../assets/videos/flat5.mp4';
import video6 from '../../../assets/videos/flat6.mp4';
import video7 from '../../../assets/videos/flat 7.mp4';
import video8 from '../../../assets/videos/WhatsApp Video 2024-09-18 at 12.23.48.mp4';
import video9 from '../../../assets/videos/WhatsApp Video 2024-09-18 at 12.24.03.mp4';
import video10 from '../../../assets/videos/WhatsApp Video 2024-09-18 at 12.25.53.mp4';
import video11 from '../../../assets/videos/WhatsApp Video 2024-09-18 at 12.28.19.mp4';
import video12 from '../../../assets/videos/no_sound.mp4';
import video13 from '../../../assets/videos/μονωση ταρατσας.mp4';

const VideoGallery = () => {
    const videoRefs = useRef([]);

    // Define videos directly inside the component
    const videos = [video0, video1, video2, video3, video4, video5, video6, video7, video8, video9, video10, video11, video12, video13];

    const handleClick = (index) => {
        const video = videoRefs.current[index];
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    };

    return (
        <div className="video-gallery">
            {videos.map((videoSrc, index) => (
                <div key={index} className="video-item">
                    <video
                        ref={(el) => videoRefs.current[index] = el}
                        controls
                        muted
                        loop
                        onClick={() => handleClick(index)}
                    >
                        <source src={videoSrc} type="video/mp4" />
                        Video not available
                    </video>
                </div>
            ))}
        </div>
    );
};

export default VideoGallery;
